import { createAccountSubmissionPreviews } from "./AccountSubmissionPreviews";

export const AccountSubmissionPreviewsAll = createAccountSubmissionPreviews(
	"account_submissions",
	(account) => !account.hasBeenActive,
);
